import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { formatDate, genericSorter } from "../../helpers/TableHelper";

export const createCommonTableColumns = (handleDetails) => [
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    render: (_, record) => (
      <div className="flex space-x-4 justify-center">
        <Button
          type="text"
          icon={<EyeOutlined />}
          size="small"
          className="border-0"
          onClick={() => handleDetails(record)}
        />
      </div>
    ),
  },
  {
    title: "Fecha",
    dataIndex: "intake_date",
    key: "intake_date",
    render: (_, record) => formatDate(record.register_date),
    sorter: genericSorter("register_date"),
  },
  {
    title: "Hora",
    dataIndex: "intake_time",
    key: "intake_time",
    render: (_, record) => formatDate(record.register_date, "HH:mm:ss"),
    sorter: genericSorter("register_date"),
  },
];

export const formatCalendarEventTime = (event) => {
  return event.start.toString().includes("00:00:00")
    ? event.title
    : require("moment")(event.start).format("HH:mm");
};

export const createNotepadTableColumns = (handleDetails, moods) => [
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    render: (_, record) => (
      <div className="flex space-x-4 justify-center">
        <Button
          type="text"
          icon={<EyeOutlined />}
          size="small"
          className="border-0"
          onClick={() => handleDetails(record)}
        />
      </div>
    ),
  },
  {
    title: "Descripción",
    dataIndex: "text",
    key: "text",
    render: (_, record) => {
      if (record.text) {
        return record.text.length > 100
          ? `${record.text.substring(0, 100)}...`
          : record.text;
      }
      return "";
    },
    sorter: genericSorter("text"),
  },
  {
    title: "Estado de ánimo",
    dataIndex: "mood",
    key: "mood",
    render: (_, record) => {
      return moods[record.mood] ?? "";
    },
    sorter: genericSorter("mood"),
  },
  {
    title: "Fecha",
    dataIndex: "intake_date",
    key: "intake_date",
    render: (_, record) => formatDate(record.register_date),
    sorter: genericSorter("register_date"),
  },
  {
    title: "Hora",
    dataIndex: "intake_time",
    key: "intake_time",
    render: (_, record) => formatDate(record.register_date, "HH:mm:ss"),
    sorter: genericSorter("register_date"),
  },
];

export const createTrainingTableColumns = (handleDetails) => [
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    render: (_, record) => (
      <div className="flex space-x-4 justify-center">
        <Button
          type="text"
          icon={<EyeOutlined />}
          size="small"
          className="border-0"
          onClick={() => handleDetails(record)}
        />
      </div>
    ),
  },
  {
    title: "Fecha",
    dataIndex: "intake_date",
    key: "intake_date",
    render: (_, record) => formatDate(record.start_datetime),
    sorter: genericSorter("start_datetime"),
  },
  {
    title: "Hora",
    dataIndex: "intake_time",
    key: "intake_time",
    render: (_, record) => formatDate(record.start_datetime, "HH:mm:ss"),
    sorter: genericSorter("start_datetime"),
  },
];

export const createPhysicalActivityTableColumns = (
  handleDetails,
  moods,
  dateSorter,
  formatDate
) => [
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    render: (_, record) => (
      <div className="flex space-x-4 justify-center">
        <Button
          type="text"
          icon={<EyeOutlined />}
          size="small"
          className="border-0"
          onClick={() => handleDetails(record)}
        />
      </div>
    ),
  },
  {
    title: "Fecha",
    dataIndex: "activity_date",
    key: "activity_date",
    render: (_, record) => formatDate(record),
    sorter: dateSorter,
  },
  {
    title: "Hora",
    dataIndex: "activity_time",
    key: "activity_time",
    render: (_, record) => formatDate(record, "HH:mm:ss"),
    sorter: dateSorter,
  },
  {
    title: "Calorías",
    dataIndex: "calories",
    key: "calories",
    sorter: (a, b) => a.calories - b.calories,
  },
  {
    title: "Estado de ánimo",
    dataIndex: "mood",
    key: "mood",
    render: (mood) => moods[mood],
  },
  {
    title: "Texto",
    dataIndex: "text",
    key: "text",
    render: (text) =>
      text.length > 100 ? `${text.substring(0, 100)}...` : text,
  },
];
